var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoadingSpinner',{attrs:{"loading":_vm.isLoading,"text":_vm.$lang.sending_data}}),(!_vm.isLoading)?_c('OptionForm',{attrs:{"mode":"add","item":_vm.item},on:{"submit":_vm.save,"cancel":_vm.cancel,"responseCode":_vm.getResponseCode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }